import { MutableRefObject, useEffect, useRef } from 'react'
import { hsl } from 'd3'

function toggle(style: CSSStyleDeclaration, prop: string, value: string): void {
    if (style.getPropertyValue(prop)) {
        style.removeProperty(prop)
    } else {
        style.setProperty(prop, value)
    }
}

export default function useBlink<T extends HTMLElement>(
    backgroundColor: string,
    interval: null | number
): MutableRefObject<T> {
    const ref = useRef<T>(null)

    useEffect(() => {
        if (ref.current) {
            const style: CSSStyleDeclaration = ref.current.style

            if (backgroundColor) {
                const color = hsl(backgroundColor).darker(2.5).toString()
                const bgColor = backgroundColor ? hsl(backgroundColor).brighter(1.5).toString() : null

                if (interval > 0) {
                    const t = setInterval(() => {
                        toggle(style, 'background-color', bgColor)
                        toggle(style, 'color', color)
                    }, interval)

                    return () => clearInterval(t)
                } else {
                    // set directly instead of toggling because if the value changes,
                    // toggling might just remove it and go to default instead of setting the new value
                    style.setProperty('background-color', bgColor)
                    style.setProperty('color', color)
                }
            } else {
                // remove to get back to defaults
                if (style.getPropertyValue('background-color')) {
                    style.removeProperty('background-color')
                }
                if (style.getPropertyValue('color')) {
                    style.removeProperty('color')
                }
            }
        }
    }, [backgroundColor, interval])

    return ref
}
